import React from "react";
import { Divider, MenuItem } from "@mui/material";

// The "Admin Tooling" group of the event Options menus: tools meant only for admins or only for dev. The divider
// label and every option in the group use the warning colour, so the group stands out from the organizer options.
export const ADMIN_TOOLING_COLOR = "warning.main";

// An array of Menu children (MUI Menu does not accept a Fragment): the labelled divider, then the options.
// items: [{ key, label, onClick, disabled? }]. Returns [] when there are no items, so an empty group never shows.
export const adminToolingMenuItems = (label, items) =>
  items?.length
    ? [
        <Divider
          key="admin-tooling-divider"
          textAlign="left"
          sx={{
            mt: 2,
            mb: 1,
            color: ADMIN_TOOLING_COLOR,
            "&::before, &::after": { borderColor: ADMIN_TOOLING_COLOR }
          }}
        >
          {label}
        </Divider>,
        ...items.map(({ key, label: itemLabel, onClick, disabled }) => (
          <MenuItem
            key={key}
            onClick={onClick}
            disabled={disabled}
            disableRipple
            sx={{ color: ADMIN_TOOLING_COLOR }}
          >
            {itemLabel}
          </MenuItem>
        ))
      ]
    : [];
